import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { apiErr } from "@/lib/api";
import { toast } from "sonner";
import Logo from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleLogin } = useApp();
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await googleLogin(decodeURIComponent(m[1]));
        toast.success("Signed in with Google!");
        navigate(user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        setError(apiErr(e));
      }
    })();
  }, []);

  return (
    <div className="min-h-[60vh] grid place-items-center px-6">
      <div className="text-center">
        <Logo />
        {error ? (
          <>
            <p className="text-red-500 mt-6">{error}</p>
            <button onClick={() => navigate("/login")} className="btn-secondary mt-4 px-6 py-3">Back to login</button>
          </>
        ) : (
          <p className="text-slate-500 mt-6">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
